export const payment_field_defs = [
    {
        key: 'id',
        label: '#',
        sortable: true
    },
    {
        key: 'transaction_code',
        label: 'Reference',
        sortable: true
    },
    {
        key: 'amount',
        sortable: true,
    },
    {
        key: 'transaction_code',
        sortable: true,
    },
    {
        key: 'account_number',
        sortable: true,
    },
    {
        key: 'phone_number',
        sortable: true,
    },
    {
        key: 'date_created',
        label: 'Date',
        sortable: true,
    },
];
